import Grid from '@mui/material/Grid';

import GridContainer from '@/components/Layout/GridContainer/GridContainer';
import type { GlobalListTextCardContent } from '@/components/TopLevelComponents/GlobalList/GlobalList';
import useGlobalStyles from '@/styles/global.styles';

import useStyles from './TextList.styles';

interface TextListProps {
  list: GlobalListTextCardContent[];
  isOnDark?: boolean | undefined;
}

export default function TextList({ list, isOnDark }: TextListProps) {
  const { classes: globalClasses } = useGlobalStyles({ fixed: true });
  const { classes, cx } = useStyles({ isOnDark });

  // biome-ignore lint/correctness/noNestedComponentDefinitions: closes over per-render props
  // biome-ignore lint/correctness/noComponentHookFactories: closes over per-render props
  const TextListRow = ({
    heading,
    body,
  }: {
    heading?: string | undefined;
    body?: string | undefined;
  }) => {
    return (
      <GridContainer fixed gridProps={{ className: classes.textList }}>
        <Grid size={6}>
          <h4 className={cx(globalClasses.h4, classes.textListHeading)}>
            {heading}
          </h4>
        </Grid>
        <Grid size={6}>
          <p className={cx(globalClasses.body, classes.textListBody)}>{body}</p>
        </Grid>
      </GridContainer>
    );
  };

  return (
    <>
      {list.map((textItem, index) => (
        <TextListRow
          key={`text-list-row-${
            // biome-ignore lint/suspicious/noArrayIndexKey: Automated migration to Biome
            index
          }`}
          {...textItem?.fields}
        />
      ))}
    </>
  );
}
